export enum AutoExportFormatterType {
    Ise,
}
